export default __webpack_public_path__ + "static/media/03-min.4db38035.jpg";